import React from 'react';

import CampaignsConfirmationModal from './CampaignsConfirmationModal';

function CampaignSaveModal(props) {
  return <CampaignsConfirmationModal {...props} />;
}

CampaignSaveModal.modalConfig = {
  fullHeightOnMobile: true,
};

export default CampaignSaveModal;
